import { render, staticRenderFns } from "./LogoutMessage.vue?vue&type=template&id=1bdfa71a&scoped=true"
import script from "./LogoutMessage.vue?vue&type=script&lang=ts"
export * from "./LogoutMessage.vue?vue&type=script&lang=ts"
import style0 from "./LogoutMessage.vue?vue&type=style&index=0&id=1bdfa71a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdfa71a",
  null
  
)

export default component.exports